














































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import ModalDelete from '@/app/ui/components/ModalDelete/index'
import ModalImage from '@/app/ui/components/ImageGallery/index.vue'
import ModalEdit from './ModalEdit.vue'
import ImageSelect from '@/app/ui/components/SelectImage/index.vue'
import { BulletinModule } from '@/app/store/modules/bulletin'

@Component({
  components: {
    'modal-delete': ModalDelete,
    'modal-image': ModalImage,
    'image-select': ImageSelect,
    'modal-edit': ModalEdit,
  },
})
export default class extends Vue {
  @Prop({}) public onPageLimit
  @Prop({}) public onPageNumChanged
  @Prop({}) public dataTable
  @Prop({}) public fields: any[] | undefined
  @Prop({}) public selected: any[] | undefined
  @Prop({}) public imageDataCategory
  @Prop({}) public clearTableStatus
  @Prop({}) public isLoading

  @Watch('clearTableStatus')
  public onPropertyChanged(value: boolean, oldValue: boolean) {
    this.$refs.selectableTables.clearSelected()
  }
  public get isFilledDataTable() {
    return (
      this.dataTable !== undefined && this.dataTable.pagination !== undefined
    )
  }
  // Form Edit
  public freeText1: string = ''
  public freeText2: string = ''
  public id: number = 0
  public title: string = ''
  public expireddate: string = ''
  public isActive: boolean = true
  public isRecommended: boolean = true
  public file: Object = {}
  public imageThumbnail: Object = {}
  public imageCover: Object = {}

  // Function Edit
  public funcEdit(item, index, button) {
    //  console.log('Salesman Item ==>', item)
    this.id = item.id
    this.freeText1 = item.fileCode.split('-')[0]
    if (item.fileCode.split('-')[2] == null) {
      this.freeText2 = item.fileCode.split('-')[1]
    } else {
      this.freeText2 =
        item.fileCode.split('-')[1] + '-' + item.fileCode.split('-')[2]
    }
    this.title = item.title
    this.isActive = item.isActive
    this.isRecommended = item.isRecommended
    this.file = item.file
    this.imageThumbnail = item.imageThumbnail
    this.imageCover = item.imageCover
    this.expireddate = item.expireddate
    this.$root.$emit('bv::show::modal', 'modal-edit', button)
  }

  public modalDelete = {
    id: 'modal-delete',
    idBulletin: 0,
    title: '',
  }
  public get buttonDisable(): boolean {
    if (this.$props.selected.length < 1) {
      return false
    } else {
      return true
    }
  }
  public $refs!: {
    selectableTables: HTMLFormElement
  }
  public onRowSelected(items) {
    this.$emit('onRowSelected', items)
  }
  public selectAllRows() {
    if (this.$props.selected.length === this.dataTable.data.length) {
      this.$refs.selectableTables.clearSelected()
    } else {
      this.$refs.selectableTables.selectAllRows()
    }
  }

  public funcDelete(item, index, button) {
    if (this.$props.selected.length < 1) {
      this.modalDelete.idBulletin = item.id
      this.modalDelete.title = item.title
      this.$root.$emit('bv::show::modal', this.modalDelete.id, button)
    }
  }
  public deleteNotif() {
    const ids = [this.modalDelete.idBulletin]
    BulletinModule.deleteBulletin({ ids })
    this.$root.$emit('bv::hide::modal', 'modal-delete')
  }
  public resetDeleteModal() {
    this.modalDelete.idBulletin = 0
    this.modalDelete.title = ''
  }

  public testing() {
    this.$emit('onTesting')
    //  console.log('testing')
  }
}
